import DownloadCertificateModal from './downloadCertificateModal'
import ErrorModal from './errorModal'
import { LoadingModal } from './loadingModal'
import NoRequestedDataFoundModal from './noRequestedDataModal'
import RewardsModal from './rewardsModal'
import ScratchCardModal from './scratchCardModal'
import WebFlowApplyModal from './webFlowApplyModal'
import WebFlowSelectorModal from './webFlowSelectorModal'
import WebVideoPlayerModal from './webVideoPlayerModal'
import YoutubeVideoModal from './youtubeVideoModal'
import ZetPrimePaymentModal from './zetPrimePaymentModal/ZetPrimePaymentModal'

const config = {
  ErrorModal: ErrorModal,
  YoutubeVideoModal: YoutubeVideoModal,
  WebFlowSelectorModal: WebFlowSelectorModal,
  ScratchCardModal: ScratchCardModal,
  NoRequestedDataFoundModal: NoRequestedDataFoundModal,
  DownloadCertificateModal: DownloadCertificateModal,
  WebFlowApplyModal: WebFlowApplyModal,
  RewardsModal: RewardsModal,
  WebVideoPlayerModal: WebVideoPlayerModal,
  ZetPrimePaymentModal: ZetPrimePaymentModal,
  LoadingModal: {
    modal: LoadingModal,
    backBehavior: 'none',
  },
}

const defaultOptions = { backdropOpacity: 0.6, disableFlingGesture: true }

interface Fields {
  key: number
  value: string
  displayValue: string
}
interface SelectorOptions {
  criteriaName: string
  fields: Fields[]
}
export interface ModalStackParams {
  YoutubeVideoModal: {
    title: string
    videoId: string
    showLanguage: boolean
    isShareEnabled: boolean
    closeCallback: Function
  }
  WebFlowSelectorModal: {
    title: string
    iconName: string
    criteriaName: string
    brandName: string
    brandCategoryId: string | number
    options: SelectorOptions[]
    event: {
      eventName: string
      eventPayload: object
    }
    selectName?: 'value' | 'displayValue'
  }
  ScratchCardModal: {
    scratchCardId: number
    amount: number
  }
  NoRequestedDataFoundModal: {
    message: string
  }
  DownloadCertificateModal: {
    certificateDescription2: string
    certificateDescription1: string
  }
  WebFlowApplyModal: {
    brandName: string
    brandLink: string
    brandLogo: string
    customerPhoneNumber: number
    modalType: string
    brandCategoryId: string | number
    displayContent?: string
    whatsappShareTemplate?: string
    openJFSLinkWithModal?: boolean
  }
  WebVideoPlayerModal: {
    videoId: string
  }
  LoadingModal: {
    title: string
  }
  ZetPrimePaymentModal: {
    title: string
    subTitle: string
  }
}

const modalConfig = {
  config,
  defaultOptions,
}
export default modalConfig
